import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import {
	getBoardType,
	getIsCompanyManaged,
	getRapidViewId,
	projectIdSelector,
} from '../selectors/app';
import {
	numCompleteIssueChildren,
	numTotalIssueChildren,
	willDetailViewShow,
} from '../selectors/cards';
import { getEstimationType } from '../selectors/estimation';
import { canEditBoardConfig } from '../selectors/permissions';
import type { State } from '../types';

type AnalyticsAttributes = {
	isIssueDetailVisible: boolean;
	boardType: string;
	projectType: string;
	boardId: string;
	projectId: number;
	isReactifiedBacklog: true;
	numSubtasks: number;
	numCompleteSubtasks: number;
	isInactiveTab: boolean;
	estimationStatistic: string | undefined;
	isProjectAdmin?: boolean;
	isUIF: boolean;
	isClassic: boolean;
};

export const getAttributes = (state: State): AnalyticsAttributes => ({
	/*
	 * isIssueDetailVisible prop is being equated with it showing in the future
	 *  because the backlog screen event is fired before the issue details
	 *  actually show, but it showing is conditional on there being a last
	 *  selected issue key
	 */
	isIssueDetailVisible: willDetailViewShow(state),
	boardType: getBoardType(state),
	projectType: SOFTWARE_PROJECT,
	boardId: getRapidViewId(state),
	projectId: projectIdSelector(state),
	isReactifiedBacklog: true,
	numSubtasks: numTotalIssueChildren(state),
	numCompleteSubtasks: numCompleteIssueChildren(state),

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	isInactiveTab: document.hidden,
	estimationStatistic: getEstimationType(state),
	isProjectAdmin: canEditBoardConfig(state),
	isUIF: true,
	isClassic: getIsCompanyManaged(state),
});
